export default {
  apiKey: "AIzaSyA5WA_Q-WjXDwWGJXjajzmOolni9Q5Us00",
  authDomain: "developer-portal-fb20b.firebaseapp.com",
  projectId: "developer-portal-fb20b",
  storageBucket: "developer-portal-fb20b.appspot.com",
  messagingSenderId: "557647664757",
  appId: "1:557647664757:web:d30bfacbfb5e0ab3e40a3c",
  measurementId: "G-TMWJ1QFL39"
};